// The page the user lands on after opening the app and without a session
export const FirstRunPage = 'WelcomePage';

// The main page the user will see as they use the app over a long period of time.
// Change this if not using tabs
export const MainPage = 'WelcomePage';

// The initial root pages for our tabs (remove if not using tabs)
export const Tab1Root = 'ListMasterPage';
export const Tab2Root = 'SearchPage';
export const Tab3Root = 'SettingsPage';

// The initial root pages for our event master (remove if not using tabs)
export const Event1Tab = 'EventAboutPage';
export const Event2Tab = 'AgendaMasterPage';
export const Event3Tab = 'EventMatchmakingPage';
export const Event4Tab = 'EventWallMasterPage';
export const Event5Tab = 'MatchmakingProfileSettingsPage';
export const Event6Tab = 'PrizeGameMasterPage';
export const Event7Tab = 'ExhibitorsPage';
export const Event8Tab = 'EventTicketPage';
export const Event9Tab = 'EventQrReaderPage';



// WEBPACK FOOTER //
// ./src/pages/pages.ts